export class ScreenersView {
  name: string;
  description?: string;
  screenerType: string;
}

export class TermsView {
  name: string;
  termType: string;
}

export class TradeDatePeriodsView {
  name: string;
  tradeDatePeriod: number;
}

export class PeriodsView {
  name: string;
  period: number;
}

export const screenersViewModel: ScreenersView[] = [
  {
    name: 'All instruments',
    screenerType: 'ALL_INSTRUMENTS'
  },
  {
    name: 'Breaking Out IVs',
    description: 'Symbols where the IVX has gone up to specified percent in the last chosen period',
    screenerType: 'BREAKING_OUT_IVS',
  },
  {
    name: 'Collapsing IVs',
    description: 'Symbols where the IVX has gone down to specified percent in the last chosen period',
    screenerType: 'COLLAPSING_IVS',
  },
  {
    name: 'High Call Volume',
    description: 'High call volume today, relative to average',
    screenerType: 'HIGH_CALL_VOLUME',
  },
  {
    name: 'High Put Volume',
    description: 'High put volume today, relative to average',
    screenerType: 'HIGH_PUT_VOLUME',
  },
  {
    name: 'Highest Call to Put Ratio',
    screenerType: 'HIGHEST_CALL_TO_PUT_RATIO',
  },
  {
    name: 'Highest Put to Call Ratio',
    screenerType: 'HIGHEST_PUT_TO_CALL_RATIO',
  }
];

export const termsViewModel: TermsView[] = [
  {
    name: '30',
    termType: 'IVX30',
  },
  {
    name: '60',
    termType: 'IVX60',
  },
  {
    name: '90',
    termType: 'IVX90',
  },
  {
    name: '120',
    termType: 'IVX120',
  },
  {
    name: '150',
    termType: 'IVX150',
  },
  {
    name: '180',
    termType: 'IVX180',
  },
];

export const tradeDatePeriodsViewModel: TradeDatePeriodsView[] = [
  {
    name: 'Week',
    tradeDatePeriod: 7,
  },
  {
    name: 'Month',
    tradeDatePeriod: 30,
  },
  {
    name: '3 month',
    tradeDatePeriod: 90,
  },
  {
    name: '6 month',
    tradeDatePeriod: 180,
  },
  {
    name: '1 year',
    tradeDatePeriod: 360,
  },
];

export const periodsViewModel: PeriodsView[] = [
  {
    name: '30 days',
    period: 30,
  },
  {
    name: '60 days',
    period: 60,
  },
  {
    name: '90 days',
    period: 90,
  },
  {
    name: '120 days',
    period: 120,
  },
];
